var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"icon"}),_c('input',{attrs:{"type":"text"}}),_c('input',{attrs:{"type":"button","value":_vm.buttonName}})])])}
var staticRenderFns = []

export { render, staticRenderFns }